import {
  NEWDANHMUCPHIEUNHAP_COUNT_ASSIGN_SUCCESS,
  NEWDANHMUCPHIEUNHAP_HISTORY_LIST_SUCCESS,
  NEWDANHMUCPHIEUNHAP_IMPORT_SUCCESS,
  NEWDANHMUCPHIEUNHAP_LIST_SUCCESS,
  NEWDANHMUCPHIEUNHAP_NEW_CARE_SUCCESS,
  NEWDANHMUCPHIEUNHAP_ONE_SUCCESS,
  NEWDANHMUCPHIEUNHAP_UPDATE_FILTER,
  NEWDANHMUCPHIEUNHAP_SAVE_SUCCESS,
  NEWDANHMUCPHIEUNHAP_UPDATE_HOMEPAGE_FILTER,
  NEWDANHMUCPHIEUNHAP_HOMEPAGE_LIST_SUCCESS,
  NEWDANHMUCPHIEUNHAP_HOMEPAGE_ONE_SUCCESS,
  NEWDANHMUCPHIEUNHAP_HANDLE_IMPORT_ERRORS,
} from 'src/actions/newdanhmucphieunhap.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageNewdanhmucphieunhapFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageNewdanhmucphieunhapPage: 0,
    homepageNewdanhmucphieunhapLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  homepageNewdanhmucphieunhapItems: [],
  homepageNewdanhmucphieunhapTotal: 0,
  homepageNewdanhmucphieunhapSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
  errorRows: {},
}

const newdanhmucphieunhapReducer = (state = initState, action) => {
  switch (action.type) {
    case NEWDANHMUCPHIEUNHAP_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case NEWDANHMUCPHIEUNHAP_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case NEWDANHMUCPHIEUNHAP_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case NEWDANHMUCPHIEUNHAP_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageNewdanhmucphieunhapFilter !== 'undefined' && state.homepageNewdanhmucphieunhapFilter) {
        if (action.data.homepageNewdanhmucphieunhapPage == 'no_update' && typeof state.homepageNewdanhmucphieunhapFilter.homepageNewdanhmucphieunhapPage !== 'undefined') action.data.homepageNewdanhmucphieunhapPage = state.homepageNewdanhmucphieunhapFilter.homepageNewdanhmucphieunhapPage;
        if (action.data.homepageNewdanhmucphieunhapLimit == 'no_update' && typeof state.homepageNewdanhmucphieunhapFilter.homepageNewdanhmucphieunhapLimit !== 'undefined') action.data.homepageNewdanhmucphieunhapLimit = state.homepageNewdanhmucphieunhapFilter.homepageNewdanhmucphieunhapLimit;
      }
      return {
        ...state,
        homepageNewdanhmucphieunhapFilter: action.data,
      }
    }
    case NEWDANHMUCPHIEUNHAP_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmucphieunhapItems: action.data.homepageNewdanhmucphieunhapItems,
        homepageNewdanhmucphieunhapTotal: action.data.homepageNewdanhmucphieunhapTotal,
      }
    }
    case NEWDANHMUCPHIEUNHAP_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmucphieunhapSelected: action.data
      }
    }
    case NEWDANHMUCPHIEUNHAP_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case NEWDANHMUCPHIEUNHAP_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case NEWDANHMUCPHIEUNHAP_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case NEWDANHMUCPHIEUNHAP_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case NEWDANHMUCPHIEUNHAP_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    case NEWDANHMUCPHIEUNHAP_HANDLE_IMPORT_ERRORS: {
      return {
        ...state,
        errorRows: action.data,
      }
    }
    default: {
      return state;
    }
  }
}
export default newdanhmucphieunhapReducer